import { connect } from 'react-redux';

import MembershipConflictModal from '../components/MembershipConflictModal';
import { wipeCart } from 'apps/cart/actions';

const mapStateToProps = state => {
  return {
    isSaving: state.isSaving,
  };
};

export const mapDispatchToProps = dispatch => ({
  wipeCart: () => {
    dispatch(wipeCart());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipConflictModal);
